export const paymentSourcesTranslations = {
  en: {
    'paymentSources.title': 'Payment Methods',
    'paymentSources.subtitle': 'Manage your funding sources',
    'paymentSources.manageAccounts': 'Manage Accounts',
    'paymentSources.balanceTopUp': 'Balance Top-Up',
    'paymentSources.addFunds': 'Add funds to your balance using your stored payment methods',
    'paymentSources.hide': 'Hide',
    'paymentSources.show': 'Show',
    'paymentSources.currentBalance': 'Current Balance',
    'paymentSources.quickTopUp': 'Quick Top-Up',
    'paymentSources.customAmount': 'Custom Amount',
    'paymentSources.enterAmount': 'Enter amount',
    'paymentSources.topUp': 'Top Up',
    'paymentSources.availableMethods': 'Available for top-up: {{count}} payment method',
    'paymentSources.availableMethods_plural': 'Available for top-up: {{count}} payment methods',
    'paymentSources.more': 'more',
    'paymentSources.addMethodPrompt': 'Add a credit card or bank account to enable balance top-up',
    'paymentSources.addMethod': 'Add Payment Method',
    'paymentSources.yourMethods': 'Your Funding Sources',
    'paymentSources.yourMethodsDesc': 'Manage credit cards, bank accounts, and digital wallets for funding transfers',
    'paymentSources.loading': 'Loading payment methods...',
    'paymentSources.noMethods': 'No payment methods',
    'paymentSources.noMethodsDesc': "Add a payment method to start funding your transactions. We'll create a secure Stripe customer profile for you.",
    'paymentSources.addFirstAccount': 'Add Your First Account',
    'paymentSources.removeTitle': 'Remove Payment Method',
    'paymentSources.removeConfirm': 'Are you sure you want to remove this payment method? This action cannot be undone.',
    'paymentSources.removeWarning': 'This will permanently remove the payment method from your account.',
    'paymentSources.removing': 'Removing...',
    'paymentSources.remove': 'Remove',
    'paymentSources.toast.defaultUpdated': 'Default payment method updated',
    'paymentSources.toast.defaultUpdatedDesc': 'Your default payment method has been changed.',
    'paymentSources.toast.errorUpdatingDefault': 'Error updating default payment method',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Failed to update default payment method',
    'paymentSources.toast.removed': 'Payment method removed',
    'paymentSources.toast.removedDesc': 'Your payment method has been successfully removed.',
    'paymentSources.toast.errorRemoving': 'Error removing payment method',
    'paymentSources.toast.errorRemovingDesc': 'Failed to remove payment method',
    'paymentSources.toast.balanceUpdated': 'Balance Updated',
    'paymentSources.toast.balanceUpdatedDesc': 'Your {{currency}} balance has been topped up successfully.',
  },
  es: {
    'paymentSources.title': 'Métodos de Pago',
    'paymentSources.subtitle': 'Gestiona tus fuentes de financiación',
    'paymentSources.manageAccounts': 'Gestionar Cuentas',
    'paymentSources.balanceTopUp': 'Recarga de Saldo',
    'paymentSources.addFunds': 'Añade fondos a tu saldo utilizando tus métodos de pago guardados',
    'paymentSources.hide': 'Ocultar',
    'paymentSources.show': 'Mostrar',
    'paymentSources.currentBalance': 'Saldo Actual',
    'paymentSources.quickTopUp': 'Recarga Rápida',
    'paymentSources.customAmount': 'Importe Personalizado',
    'paymentSources.enterAmount': 'Introduce el importe',
    'paymentSources.topUp': 'Recargar',
    'paymentSources.availableMethods': 'Disponible para recarga: {{count}} método de pago',
    'paymentSources.availableMethods_plural': 'Disponibles para recarga: {{count}} métodos de pago',
    'paymentSources.more': 'más',
    'paymentSources.addMethodPrompt': 'Añade una tarjeta de crédito o cuenta bancaria para habilitar la recarga de saldo',
    'paymentSources.addMethod': 'Añadir Método de Pago',
    'paymentSources.yourMethods': 'Tus Fuentes de Financiación',
    'paymentSources.yourMethodsDesc': 'Gestiona tarjetas de crédito, cuentas bancarias y carteras digitales para financiar transferencias',
    'paymentSources.loading': 'Cargando métodos de pago...',
    'paymentSources.noMethods': 'No hay métodos de pago',
    'paymentSources.noMethodsDesc': 'Añade un método de pago para empezar a financiar tus transacciones. Crearemos un perfil de cliente seguro en Stripe para ti.',
    'paymentSources.addFirstAccount': 'Añade Tu Primera Cuenta',
    'paymentSources.removeTitle': 'Eliminar Método de Pago',
    'paymentSources.removeConfirm': '¿Estás seguro de que quieres eliminar este método de pago? Esta acción no se puede deshacer.',
    'paymentSources.removeWarning': 'Esto eliminará permanentemente el método de pago de tu cuenta.',
    'paymentSources.removing': 'Eliminando...',
    'paymentSources.remove': 'Eliminar',
    'paymentSources.toast.defaultUpdated': 'Método de pago predeterminado actualizado',
    'paymentSources.toast.defaultUpdatedDesc': 'Tu método de pago predeterminado ha sido cambiado.',
    'paymentSources.toast.errorUpdatingDefault': 'Error al actualizar el método de pago predeterminado',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'No se pudo actualizar el método de pago predeterminado',
    'paymentSources.toast.removed': 'Método de pago eliminado',
    'paymentSources.toast.removedDesc': 'Tu método de pago ha sido eliminado correctamente.',
    'paymentSources.toast.errorRemoving': 'Error al eliminar el método de pago',
    'paymentSources.toast.errorRemovingDesc': 'No se pudo eliminar el método de pago',
    'paymentSources.toast.balanceUpdated': 'Saldo Actualizado',
    'paymentSources.toast.balanceUpdatedDesc': 'Tu saldo de {{currency}} ha sido recargado correctamente.',
  },
  fr: {
    'paymentSources.title': 'Méthodes de paiement',
    'paymentSources.subtitle': 'Gérez vos sources de financement',
    'paymentSources.manageAccounts': 'Gérer les comptes',
    'paymentSources.balanceTopUp': 'Recharge de solde',
    'paymentSources.addFunds': 'Ajoutez des fonds à votre solde en utilisant vos méthodes de paiement enregistrées',
    'paymentSources.hide': 'Masquer',
    'paymentSources.show': 'Afficher',
    'paymentSources.currentBalance': 'Solde actuel',
    'paymentSources.quickTopUp': 'Recharge rapide',
    'paymentSources.customAmount': 'Montant personnalisé',
    'paymentSources.enterAmount': 'Entrez le montant',
    'paymentSources.topUp': 'Recharger',
    'paymentSources.availableMethods': 'Disponible pour recharge : {{count}} méthode de paiement',
    'paymentSources.availableMethods_plural': 'Disponibles pour recharge : {{count}} méthodes de paiement',
    'paymentSources.more': 'plus',
    'paymentSources.addMethodPrompt': 'Ajoutez une carte de crédit ou un compte bancaire pour activer la recharge de solde',
    'paymentSources.addMethod': 'Ajouter une méthode de paiement',
    'paymentSources.yourMethods': 'Vos sources de financement',
    'paymentSources.yourMethodsDesc': 'Gérez les cartes de crédit, comptes bancaires et portefeuilles numériques pour les transferts de financement',
    'paymentSources.loading': 'Chargement des méthodes de paiement...',
    'paymentSources.noMethods': 'Aucune méthode de paiement',
    'paymentSources.noMethodsDesc': 'Ajoutez une méthode de paiement pour commencer à financer vos transactions. Nous créerons un profil client Stripe sécurisé pour vous.',
    'paymentSources.addFirstAccount': 'Ajoutez votre premier compte',
    'paymentSources.removeTitle': 'Supprimer la méthode de paiement',
    'paymentSources.removeConfirm': 'Êtes-vous sûr de vouloir supprimer cette méthode de paiement ? Cette action ne peut pas être annulée.',
    'paymentSources.removeWarning': 'Cela supprimera définitivement la méthode de paiement de votre compte.',
    'paymentSources.removing': 'Suppression...',
    'paymentSources.remove': 'Supprimer',
    'paymentSources.toast.defaultUpdated': 'Méthode de paiement par défaut mise à jour',
    'paymentSources.toast.defaultUpdatedDesc': 'Votre méthode de paiement par défaut a été modifiée.',
    'paymentSources.toast.errorUpdatingDefault': 'Erreur lors de la mise à jour de la méthode de paiement par défaut',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Échec de la mise à jour de la méthode de paiement par défaut',
    'paymentSources.toast.removed': 'Méthode de paiement supprimée',
    'paymentSources.toast.removedDesc': 'Votre méthode de paiement a été supprimée avec succès.',
    'paymentSources.toast.errorRemoving': 'Erreur lors de la suppression de la méthode de paiement',
    'paymentSources.toast.errorRemovingDesc': 'Échec de la suppression de la méthode de paiement',
    'paymentSources.toast.balanceUpdated': 'Solde mis à jour',
    'paymentSources.toast.balanceUpdatedDesc': 'Votre solde {{currency}} a été rechargé avec succès.',
  },
  sq: {
    'paymentSources.title': 'Metodat e Pagesës',
    'paymentSources.subtitle': 'Menaxhoni burimet tuaja të financimit',
    'paymentSources.manageAccounts': 'Menaxho Llogaritë',
    'paymentSources.balanceTopUp': 'Rimbushje Bilanci',
    'paymentSources.addFunds': 'Shtoni fonde në bilancin tuaj duke përdorur metodat e pagesës të ruajtura',
    'paymentSources.hide': 'Fshih',
    'paymentSources.show': 'Shfaq',
    'paymentSources.currentBalance': 'Bilanci Aktual',
    'paymentSources.quickTopUp': 'Rimbushje e Shpejtë',
    'paymentSources.customAmount': 'Shumë e Personalizuar',
    'paymentSources.enterAmount': 'Vendosni shumën',
    'paymentSources.topUp': 'Rimbush',
    'paymentSources.availableMethods': 'Në dispozicion për rimbushje: {{count}} metodë pagese',
    'paymentSources.availableMethods_plural': 'Në dispozicion për rimbushje: {{count}} metoda pagese',
    'paymentSources.more': 'më shumë',
    'paymentSources.addMethodPrompt': 'Shtoni një kartë krediti ose llogari bankare për të aktivizuar rimbushjen e bilancit',
    'paymentSources.addMethod': 'Shto Metodë Pagese',
    'paymentSources.yourMethods': 'Burimet tuaja të Financimit',
    'paymentSources.yourMethodsDesc': 'Menaxhoni kartat e kreditit, llogaritë bankare dhe portofolët digjitalë për transferta fondesh',
    'paymentSources.loading': 'Duke ngarkuar metodat e pagesës...',
    'paymentSources.noMethods': 'Nuk ka metoda pagese',
    'paymentSources.noMethodsDesc': 'Shtoni një metodë pagese për të filluar financimin e transaksioneve tuaja. Ne do të krijojmë një profil të sigurt klienti Stripe për ju.',
    'paymentSources.addFirstAccount': 'Shtoni Llogarinë Tuaj të Parë',
    'paymentSources.removeTitle': 'Hiq Metodën e Pagesës',
    'paymentSources.removeConfirm': 'Jeni të sigurt që dëshironi të hiqni këtë metodë pagese? Ky veprim nuk mund të anulohet.',
    'paymentSources.removeWarning': 'Kjo do të heqë përgjithmonë metodën e pagesës nga llogaria juaj.',
    'paymentSources.removing': 'Duke hequr...',
    'paymentSources.remove': 'Hiq',
    'paymentSources.toast.defaultUpdated': 'Metoda e pagesës e paracaktuar u përditësua',
    'paymentSources.toast.defaultUpdatedDesc': 'Metoda juaj e pagesës e paracaktuar është ndryshuar.',
    'paymentSources.toast.errorUpdatingDefault': 'Gabim gjatë përditësimit të metodës së pagesës së paracaktuar',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Dështoi përditësimi i metodës së pagesës së paracaktuar',
    'paymentSources.toast.removed': 'Metoda e pagesës u hoq',
    'paymentSources.toast.removedDesc': 'Metoda juaj e pagesës është hequr me sukses.',
    'paymentSources.toast.errorRemoving': 'Gabim gjatë heqjes së metodës së pagesës',
    'paymentSources.toast.errorRemovingDesc': 'Dështoi heqja e metodës së pagesës',
    'paymentSources.toast.balanceUpdated': 'Bilanci u Përditësua',
    'paymentSources.toast.balanceUpdatedDesc': 'Bilanci juaj i {{currency}} është rimbushur me sukses.',
  },
  ru: {
    'paymentSources.title': 'Способы оплаты',
    'paymentSources.subtitle': 'Управляйте источниками финансирования',
    'paymentSources.manageAccounts': 'Управление счетами',
    'paymentSources.balanceTopUp': 'Пополнение баланса',
    'paymentSources.addFunds': 'Пополните баланс, используя сохраненные способы оплаты',
    'paymentSources.hide': 'Скрыть',
    'paymentSources.show': 'Показать',
    'paymentSources.currentBalance': 'Текущий баланс',
    'paymentSources.quickTopUp': 'Быстрое пополнение',
    'paymentSources.customAmount': 'Пользовательская сумма',
    'paymentSources.enterAmount': 'Введите сумму',
    'paymentSources.topUp': 'Пополнить',
    'paymentSources.availableMethods': 'Доступно для пополнения: {{count}} способ оплаты',
    'paymentSources.availableMethods_plural': 'Доступно для пополнения: {{count}} способов оплаты',
    'paymentSources.more': 'еще',
    'paymentSources.addMethodPrompt': 'Добавьте кредитную карту или банковский счет для пополнения баланса',
    'paymentSources.addMethod': 'Добавить способ оплаты',
    'paymentSources.yourMethods': 'Ваши источники финансирования',
    'paymentSources.yourMethodsDesc': 'Управляйте кредитными картами, банковскими счетами и цифровыми кошельками для финансирования переводов',
    'paymentSources.loading': 'Загрузка способов оплаты...',
    'paymentSources.noMethods': 'Нет способов оплаты',
    'paymentSources.noMethodsDesc': 'Добавьте способ оплаты, чтобы начать финансировать транзакции. Мы создадим безопасный профиль клиента Stripe для вас.',
    'paymentSources.addFirstAccount': 'Добавьте ваш первый счет',
    'paymentSources.removeTitle': 'Удалить способ оплаты',
    'paymentSources.removeConfirm': 'Вы уверены, что хотите удалить этот способ оплаты? Это действие нельзя отменить.',
    'paymentSources.removeWarning': 'Это навсегда удалит способ оплаты из вашего аккаунта.',
    'paymentSources.removing': 'Удаление...',
    'paymentSources.remove': 'Удалить',
    'paymentSources.toast.defaultUpdated': 'Способ оплаты по умолчанию обновлен',
    'paymentSources.toast.defaultUpdatedDesc': 'Ваш способ оплаты по умолчанию был изменен.',
    'paymentSources.toast.errorUpdatingDefault': 'Ошибка обновления способа оплаты по умолчанию',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Не удалось обновить способ оплаты по умолчанию',
    'paymentSources.toast.removed': 'Способ оплаты удален',
    'paymentSources.toast.removedDesc': 'Ваш способ оплаты успешно удален.',
    'paymentSources.toast.errorRemoving': 'Ошибка удаления способа оплаты',
    'paymentSources.toast.errorRemovingDesc': 'Не удалось удалить способ оплаты',
    'paymentSources.toast.balanceUpdated': 'Баланс обновлен',
    'paymentSources.toast.balanceUpdatedDesc': 'Ваш баланс {{currency}} успешно пополнен.',
  },
  pt: {
    'paymentSources.title': 'Métodos de Pagamento',
    'paymentSources.subtitle': 'Gerencie suas fontes de financiamento',
    'paymentSources.manageAccounts': 'Gerenciar Contas',
    'paymentSources.balanceTopUp': 'Recarga de Saldo',
    'paymentSources.addFunds': 'Adicione fundos ao seu saldo usando seus métodos de pagamento salvos',
    'paymentSources.hide': 'Ocultar',
    'paymentSources.show': 'Mostrar',
    'paymentSources.currentBalance': 'Saldo Atual',
    'paymentSources.quickTopUp': 'Recarga Rápida',
    'paymentSources.customAmount': 'Valor Personalizado',
    'paymentSources.enterAmount': 'Insira o valor',
    'paymentSources.topUp': 'Recarregar',
    'paymentSources.availableMethods': 'Disponível para recarga: {{count}} método de pagamento',
    'paymentSources.availableMethods_plural': 'Disponível para recarga: {{count}} métodos de pagamento',
    'paymentSources.more': 'mais',
    'paymentSources.addMethodPrompt': 'Adicione um cartão de crédito ou conta bancária para habilitar a recarga de saldo',
    'paymentSources.addMethod': 'Adicionar Método de Pagamento',
    'paymentSources.yourMethods': 'Suas Fontes de Financiamento',
    'paymentSources.yourMethodsDesc': 'Gerencie cartões de crédito, contas bancárias e carteiras digitais para financiar transferências',
    'paymentSources.loading': 'Carregando métodos de pagamento...',
    'paymentSources.noMethods': 'Nenhum método de pagamento',
    'paymentSources.noMethodsDesc': 'Adicione um método de pagamento para começar a financiar suas transações. Criaremos um perfil de cliente Stripe seguro para você.',
    'paymentSources.addFirstAccount': 'Adicione Sua Primeira Conta',
    'paymentSources.removeTitle': 'Remover Método de Pagamento',
    'paymentSources.removeConfirm': 'Tem certeza de que deseja remover este método de pagamento? Esta ação não pode ser desfeita.',
    'paymentSources.removeWarning': 'Isso removerá permanentemente o método de pagamento da sua conta.',
    'paymentSources.removing': 'Removendo...',
    'paymentSources.remove': 'Remover',
    'paymentSources.toast.defaultUpdated': 'Método de pagamento padrão atualizado',
    'paymentSources.toast.defaultUpdatedDesc': 'Seu método de pagamento padrão foi alterado.',
    'paymentSources.toast.errorUpdatingDefault': 'Erro ao atualizar método de pagamento padrão',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Falha ao atualizar método de pagamento padrão',
    'paymentSources.toast.removed': 'Método de pagamento removido',
    'paymentSources.toast.removedDesc': 'Seu método de pagamento foi removido com sucesso.',
    'paymentSources.toast.errorRemoving': 'Erro ao remover método de pagamento',
    'paymentSources.toast.errorRemovingDesc': 'Falha ao remover método de pagamento',
    'paymentSources.toast.balanceUpdated': 'Saldo Atualizado',
    'paymentSources.toast.balanceUpdatedDesc': 'Seu saldo {{currency}} foi recarregado com sucesso.',
  },
  el: {
    'paymentSources.title': 'Μέθοδοι Πληρωμής',
    'paymentSources.subtitle': 'Διαχειριστείτε τις πηγές χρηματοδότησής σας',
    'paymentSources.manageAccounts': 'Διαχείριση Λογαριασμών',
    'paymentSources.balanceTopUp': 'Ανανέωση Υπολοίπου',
    'paymentSources.addFunds': 'Προσθέστε χρήματα στο υπόλοιπό σας χρησιμοποιώντας τις αποθηκευμένες μεθόδους πληρωμής σας',
    'paymentSources.hide': 'Απόκρυψη',
    'paymentSources.show': 'Εμφάνιση',
    'paymentSources.currentBalance': 'Τρέχον Υπόλοιπο',
    'paymentSources.quickTopUp': 'Γρήγορη Ανανέωση',
    'paymentSources.customAmount': 'Προσαρμοσμένο Ποσό',
    'paymentSources.enterAmount': 'Εισάγετε ποσό',
    'paymentSources.topUp': 'Ανανέωση',
    'paymentSources.availableMethods': 'Διαθέσιμο για ανανέωση: {{count}} μέθοδος πληρωμής',
    'paymentSources.availableMethods_plural': 'Διαθέσιμο για ανανέωση: {{count}} μέθοδοι πληρωμής',
    'paymentSources.more': 'περισσότερα',
    'paymentSources.addMethodPrompt': 'Προσθέστε μια πιστωτική κάρτα ή τραπεζικό λογαριασμό για να ενεργοποιήσετε την ανανέωση υπολοίπου',
    'paymentSources.addMethod': 'Προσθήκη Μεθόδου Πληρωμής',
    'paymentSources.yourMethods': 'Οι Πηγές Χρηματοδότησής Σας',
    'paymentSources.yourMethodsDesc': 'Διαχειριστείτε πιστωτικές κάρτες, τραπεζικούς λογαριασμούς και ψηφιακά πορτοφόλια για μεταφορές χρηματοδότησης',
    'paymentSources.loading': 'Φόρτωση μεθόδων πληρωμής...',
    'paymentSources.noMethods': 'Δεν υπάρχουν μέθοδοι πληρωμής',
    'paymentSources.noMethodsDesc': 'Προσθέστε μια μέθοδο πληρωμής για να ξεκινήσετε τη χρηματοδότηση των συναλλαγών σας. Θα δημιουργήσουμε ένα ασφαλές προφίλ πελάτη Stripe για εσάς.',
    'paymentSources.addFirstAccount': 'Προσθέστε τον Πρώτο Σας Λογαριασμό',
    'paymentSources.removeTitle': 'Αφαίρεση Μεθόδου Πληρωμής',
    'paymentSources.removeConfirm': 'Είστε βέβαιοι ότι θέλετε να αφαιρέσετε αυτή τη μέθοδο πληρωμής; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    'paymentSources.removeWarning': 'Αυτό θα αφαιρέσει μόνιμα τη μέθοδο πληρωμής από τον λογαριασμό σας.',
    'paymentSources.removing': 'Αφαίρεση...',
    'paymentSources.remove': 'Αφαίρεση',
    'paymentSources.toast.defaultUpdated': 'Η προεπιλεγμένη μέθοδος πληρωμής ενημερώθηκε',
    'paymentSources.toast.defaultUpdatedDesc': 'Η προεπιλεγμένη μέθοδος πληρωμής σας έχει αλλάξει.',
    'paymentSources.toast.errorUpdatingDefault': 'Σφάλμα ενημέρωσης προεπιλεγμένης μεθόδου πληρωμής',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Αποτυχία ενημέρωσης προεπιλεγμένης μεθόδου πληρωμής',
    'paymentSources.toast.removed': 'Η μέθοδος πληρωμής αφαιρέθηκε',
    'paymentSources.toast.removedDesc': 'Η μέθοδος πληρωμής σας αφαιρέθηκε με επιτυχία.',
    'paymentSources.toast.errorRemoving': 'Σφάλμα κατά την αφαίρεση μεθόδου πληρωμής',
    'paymentSources.toast.errorRemovingDesc': 'Αποτυχία αφαίρεσης μεθόδου πληρωμής',
    'paymentSources.toast.balanceUpdated': 'Το Υπόλοιπο Ενημερώθηκε',
    'paymentSources.toast.balanceUpdatedDesc': 'Το υπόλοιπο {{currency}} σας ανανεώθηκε με επιτυχία.',
  },
  de: {
    'paymentSources.title': 'Zahlungsmethoden',
    'paymentSources.subtitle': 'Verwalten Sie Ihre Finanzierungsquellen',
    'paymentSources.manageAccounts': 'Konten verwalten',
    'paymentSources.balanceTopUp': 'Guthaben aufladen',
    'paymentSources.addFunds': 'Fügen Sie Geld zu Ihrem Guthaben hinzu, indem Sie Ihre gespeicherten Zahlungsmethoden verwenden',
    'paymentSources.hide': 'Ausblenden',
    'paymentSources.show': 'Anzeigen',
    'paymentSources.currentBalance': 'Aktuelles Guthaben',
    'paymentSources.quickTopUp': 'Schnellaufladung',
    'paymentSources.customAmount': 'Benutzerdefinierter Betrag',
    'paymentSources.enterAmount': 'Betrag eingeben',
    'paymentSources.topUp': 'Aufladen',
    'paymentSources.availableMethods': 'Verfügbar für Aufladung: {{count}} Zahlungsmethode',
    'paymentSources.availableMethods_plural': 'Verfügbar für Aufladung: {{count}} Zahlungsmethoden',
    'paymentSources.more': 'mehr',
    'paymentSources.addMethodPrompt': 'Fügen Sie eine Kreditkarte oder ein Bankkonto hinzu, um die Guthabenaufladung zu aktivieren',
    'paymentSources.addMethod': 'Zahlungsmethode hinzufügen',
    'paymentSources.yourMethods': 'Ihre Finanzierungsquellen',
    'paymentSources.yourMethodsDesc': 'Verwalten Sie Kreditkarten, Bankkonten und digitale Geldbörsen für Finanzierungstransfers',
    'paymentSources.loading': 'Zahlungsmethoden werden geladen...',
    'paymentSources.noMethods': 'Keine Zahlungsmethoden',
    'paymentSources.noMethodsDesc': 'Fügen Sie eine Zahlungsmethode hinzu, um Ihre Transaktionen zu finanzieren. Wir erstellen ein sicheres Stripe-Kundenprofil für Sie.',
    'paymentSources.addFirstAccount': 'Ihr erstes Konto hinzufügen',
    'paymentSources.removeTitle': 'Zahlungsmethode entfernen',
    'paymentSources.removeConfirm': 'Sind Sie sicher, dass Sie diese Zahlungsmethode entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'paymentSources.removeWarning': 'Dies entfernt die Zahlungsmethode dauerhaft von Ihrem Konto.',
    'paymentSources.removing': 'Wird entfernt...',
    'paymentSources.remove': 'Entfernen',
    'paymentSources.toast.defaultUpdated': 'Standard-Zahlungsmethode aktualisiert',
    'paymentSources.toast.defaultUpdatedDesc': 'Ihre Standard-Zahlungsmethode wurde geändert.',
    'paymentSources.toast.errorUpdatingDefault': 'Fehler beim Aktualisieren der Standard-Zahlungsmethode',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Standard-Zahlungsmethode konnte nicht aktualisiert werden',
    'paymentSources.toast.removed': 'Zahlungsmethode entfernt',
    'paymentSources.toast.removedDesc': 'Ihre Zahlungsmethode wurde erfolgreich entfernt.',
    'paymentSources.toast.errorRemoving': 'Fehler beim Entfernen der Zahlungsmethode',
    'paymentSources.toast.errorRemovingDesc': 'Zahlungsmethode konnte nicht entfernt werden',
    'paymentSources.toast.balanceUpdated': 'Guthaben aktualisiert',
    'paymentSources.toast.balanceUpdatedDesc': 'Ihr {{currency}}-Guthaben wurde erfolgreich aufgeladen.',
  },
  ro: {
    'paymentSources.title': 'Metode de Plată',
    'paymentSources.subtitle': 'Gestionați sursele dvs. de finanțare',
    'paymentSources.manageAccounts': 'Gestionare Conturi',
    'paymentSources.balanceTopUp': 'Încărcare Sold',
    'paymentSources.addFunds': 'Adăugați fonduri la soldul dvs. folosind metodele dvs. de plată salvate',
    'paymentSources.hide': 'Ascunde',
    'paymentSources.show': 'Afișează',
    'paymentSources.currentBalance': 'Sold Actual',
    'paymentSources.quickTopUp': 'Încărcare Rapidă',
    'paymentSources.customAmount': 'Sumă Personalizată',
    'paymentSources.enterAmount': 'Introduceți suma',
    'paymentSources.topUp': 'Încarcă',
    'paymentSources.availableMethods': 'Disponibil pentru încărcare: {{count}} metodă de plată',
    'paymentSources.availableMethods_plural': 'Disponibil pentru încărcare: {{count}} metode de plată',
    'paymentSources.more': 'mai mult',
    'paymentSources.addMethodPrompt': 'Adăugați un card de credit sau cont bancar pentru a activa încărcarea soldului',
    'paymentSources.addMethod': 'Adaugă Metodă de Plată',
    'paymentSources.yourMethods': 'Sursele Dvs. de Finanțare',
    'paymentSources.yourMethodsDesc': 'Gestionați carduri de credit, conturi bancare și portofele digitale pentru transferuri de finanțare',
    'paymentSources.loading': 'Se încarcă metodele de plată...',
    'paymentSources.noMethods': 'Fără metode de plată',
    'paymentSources.noMethodsDesc': 'Adăugați o metodă de plată pentru a începe să finanțați tranzacțiile. Vom crea un profil de client Stripe sigur pentru dvs.',
    'paymentSources.addFirstAccount': 'Adăugați Primul Dvs. Cont',
    'paymentSources.removeTitle': 'Eliminare Metodă de Plată',
    'paymentSources.removeConfirm': 'Sunteți sigur că doriți să eliminați această metodă de plată? Această acțiune nu poate fi anulată.',
    'paymentSources.removeWarning': 'Aceasta va elimina permanent metoda de plată din contul dvs.',
    'paymentSources.removing': 'Se elimină...',
    'paymentSources.remove': 'Elimină',
    'paymentSources.toast.defaultUpdated': 'Metodă de plată implicită actualizată',
    'paymentSources.toast.defaultUpdatedDesc': 'Metoda dvs. de plată implicită a fost schimbată.',
    'paymentSources.toast.errorUpdatingDefault': 'Eroare la actualizarea metodei de plată implicite',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Nu s-a putut actualiza metoda de plată implicită',
    'paymentSources.toast.removed': 'Metodă de plată eliminată',
    'paymentSources.toast.removedDesc': 'Metoda dvs. de plată a fost eliminată cu succes.',
    'paymentSources.toast.errorRemoving': 'Eroare la eliminarea metodei de plată',
    'paymentSources.toast.errorRemovingDesc': 'Nu s-a putut elimina metoda de plată',
    'paymentSources.toast.balanceUpdated': 'Sold Actualizat',
    'paymentSources.toast.balanceUpdatedDesc': 'Soldul dvs. {{currency}} a fost încărcat cu succes.',
  },
  sr: {
    'paymentSources.title': 'Начини плаћања',
    'paymentSources.subtitle': 'Управљајте вашим изворима финансирања',
    'paymentSources.manageAccounts': 'Управљај налозима',
    'paymentSources.balanceTopUp': 'Допуна стања',
    'paymentSources.addFunds': 'Додајте средства на ваш салдо користећи сачуване начине плаћања',
    'paymentSources.hide': 'Сакриј',
    'paymentSources.show': 'Прикажи',
    'paymentSources.currentBalance': 'Тренутно стање',
    'paymentSources.quickTopUp': 'Брза допуна',
    'paymentSources.customAmount': 'Прилагођени износ',
    'paymentSources.enterAmount': 'Унесите износ',
    'paymentSources.topUp': 'Допуни',
    'paymentSources.availableMethods': 'Доступно за допуну: {{count}} начин плаћања',
    'paymentSources.availableMethods_plural': 'Доступно за допуну: {{count}} начина плаћања',
    'paymentSources.more': 'више',
    'paymentSources.addMethodPrompt': 'Додајте кредитну картицу или банковни рачун да бисте омогућили допуну стања',
    'paymentSources.addMethod': 'Додај начин плаћања',
    'paymentSources.yourMethods': 'Ваши извори финансирања',
    'paymentSources.yourMethodsDesc': 'Управљајте кредитним картицама, банковним рачунима и дигиталним новчаницима за финансирање трансфера',
    'paymentSources.loading': 'Учитавање начина плаћања...',
    'paymentSources.noMethods': 'Нема начина плаћања',
    'paymentSources.noMethodsDesc': 'Додајте начин плаћања да бисте почели да финансирате своје трансакције. Направићемо сигуран Стрипе кориснички профил за вас.',
    'paymentSources.addFirstAccount': 'Додајте свој први налог',
    'paymentSources.removeTitle': 'Уклони начин плаћања',
    'paymentSources.removeConfirm': 'Да ли сте сигурни да желите да уклоните овај начин плаћања? Ова радња се не може опозвати.',
    'paymentSources.removeWarning': 'Ово ће трајно уклонити начин плаћања са вашег налога.',
    'paymentSources.removing': 'Уклањање...',
    'paymentSources.remove': 'Уклони',
    'paymentSources.toast.defaultUpdated': 'Подразумевани начин плаћања је ажуриран',
    'paymentSources.toast.defaultUpdatedDesc': 'Ваш подразумевани начин плаћања је промењен.',
    'paymentSources.toast.errorUpdatingDefault': 'Грешка при ажурирању подразумеваног начина плаћања',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Није успело ажурирање подразумеваног начина плаћања',
    'paymentSources.toast.removed': 'Начин плаћања је уклоњен',
    'paymentSources.toast.removedDesc': 'Ваш начин плаћања је успешно уклоњен.',
    'paymentSources.toast.errorRemoving': 'Грешка при уклањању начина плаћања',
    'paymentSources.toast.errorRemovingDesc': 'Није успело уклањање начина плаћања',
    'paymentSources.toast.balanceUpdated': 'Стање ажурирано',
    'paymentSources.toast.balanceUpdatedDesc': 'Ваше стање у {{currency}} је успешно допуњено.',
  },
  pl: {
    'paymentSources.title': 'Metody Płatności',
    'paymentSources.subtitle': 'Zarządzaj swoimi źródłami finansowania',
    'paymentSources.manageAccounts': 'Zarządzaj Kontami',
    'paymentSources.balanceTopUp': 'Dopłata Salda',
    'paymentSources.addFunds': 'Dodaj środki do swojego salda używając zapisanych metod płatności',
    'paymentSources.hide': 'Ukryj',
    'paymentSources.show': 'Pokaż',
    'paymentSources.currentBalance': 'Aktualne Saldo',
    'paymentSources.quickTopUp': 'Szybka Dopłata',
    'paymentSources.customAmount': 'Niestandardowa Kwota',
    'paymentSources.enterAmount': 'Wprowadź kwotę',
    'paymentSources.topUp': 'Dopłać',
    'paymentSources.availableMethods': 'Dostępne do dopłaty: {{count}} metoda płatności',
    'paymentSources.availableMethods_plural': 'Dostępne do dopłaty: {{count}} metod płatności',
    'paymentSources.more': 'więcej',
    'paymentSources.addMethodPrompt': 'Dodaj kartę kredytową lub konto bankowe, aby włączyć dopłatę salda',
    'paymentSources.addMethod': 'Dodaj Metodę Płatności',
    'paymentSources.yourMethods': 'Twoje Źródła Finansowania',
    'paymentSources.yourMethodsDesc': 'Zarządzaj kartami kredytowymi, kontami bankowymi i portfelami cyfrowymi do finansowania transferów',
    'paymentSources.loading': 'Ładowanie metod płatności...',
    'paymentSources.noMethods': 'Brak metod płatności',
    'paymentSources.noMethodsDesc': 'Dodaj metodę płatności, aby zacząć finansować swoje transakcje. Utworzymy bezpieczny profil klienta Stripe dla Ciebie.',
    'paymentSources.addFirstAccount': 'Dodaj Swoje Pierwsze Konto',
    'paymentSources.removeTitle': 'Usuń Metodę Płatności',
    'paymentSources.removeConfirm': 'Czy na pewno chcesz usunąć tę metodę płatności? Ta akcja nie może zostać cofnięta.',
    'paymentSources.removeWarning': 'To trwale usunie metodę płatności z Twojego konta.',
    'paymentSources.removing': 'Usuwanie...',
    'paymentSources.remove': 'Usuń',
    'paymentSources.toast.defaultUpdated': 'Domyślna metoda płatności zaktualizowana',
    'paymentSources.toast.defaultUpdatedDesc': 'Twoja domyślna metoda płatności została zmieniona.',
    'paymentSources.toast.errorUpdatingDefault': 'Błąd podczas aktualizacji domyślnej metody płatności',
    'paymentSources.toast.errorUpdatingDefaultDesc': 'Nie udało się zaktualizować domyślnej metody płatności',
    'paymentSources.toast.removed': 'Metoda płatności usunięta',
    'paymentSources.toast.removedDesc': 'Twoja metoda płatności została pomyślnie usunięta.',
    'paymentSources.toast.errorRemoving': 'Błąd podczas usuwania metody płatności',
    'paymentSources.toast.errorRemovingDesc': 'Nie udało się usunąć metody płatności',
    'paymentSources.toast.balanceUpdated': 'Saldo Zaktualizowane',
    'paymentSources.toast.balanceUpdatedDesc': 'Twoje saldo {{currency}} zostało pomyślnie dopłacone.',
  },
};
